import { createFileRoute } from '@tanstack/react-router';
import { AdminAccountsPage } from '@/features/admin-accounts';

export const Route = createFileRoute('/_authenticated/_admin/admin-accounts')({
  component: AdminAccountsPage,
});
